import { useLocalObservable } from 'mobx-react';
import React, { useContext } from 'react';

import AppStore from './AppStore';
import UserStore from './UserStore';

export const GlobalStores = {
    appStore: new AppStore(),
    userStore: new UserStore(),
};

const GlobalStoresContext = React.createContext<typeof GlobalStores | null>(null);

export const GlobalStoresProvider = (props: React.PropsWithChildren<unknown>) => {
    const store = useLocalObservable<typeof GlobalStores>(() => GlobalStores);

    return <GlobalStoresContext.Provider value={store}>{props.children}</GlobalStoresContext.Provider>;
};

const useGlobalStores = () => useContext(GlobalStoresContext);

export const useAppStore = () => {
    const globalStores = useGlobalStores();
    if (!globalStores) throw new Error('No global stores context. Is there a wrapping provider?');
    return globalStores.appStore;
};

export { useLookupStore } from './LookupStore';

export const useUserStore = () => {
    const globalStores = useGlobalStores();
    if (!globalStores) throw new Error('No global stores context. Is there a wrapping provider?');
    return globalStores.userStore;
};
